import { Box, Chip, Divider, Stack, Typography } from '@mui/material';
import React from 'react';
import pkg from '../../package.json';
import AppLogo from './AppLogo';
import { useServices } from './ServiceProvider';
import { Icon } from '../core/icon';
import { renderIcon } from './renderIcon';
const version = `v${pkg.version}`;
const versionLabel = pkg.versionLabel;
const GUTTER = '1em';
const AboutView = () => {
    const { platformAPI } = useServices();
    const platformInfo = platformAPI.getPlatformInfo();
    return (React.createElement(Box, { sx: {
            userSelect: 'none',
            padding: '1em 0.5em',
        } },
        React.createElement(Stack, { direction: "row", spacing: "0.5em", alignItems: "flex-start" },
            React.createElement(AppLogo, { fontSize: "large" }),
            React.createElement(Typography, { sx: { paddingRight: '0.25em' }, variant: "h4" }, "Hexelate")),
        React.createElement(Box, { sx: { marginLeft: GUTTER, marginTop: '1em' } },
            React.createElement(Typography, null, "A campaign setting builder for tabletop games."),
            React.createElement(Typography, null, "\u00A9 Kevin Garsjo")),
        React.createElement(Divider, { textAlign: 'left', sx: { marginBottom: '1em', marginTop: '1em' } },
            React.createElement(Chip, { label: "Versions" })),
        React.createElement(Stack, { sx: { marginLeft: GUTTER }, spacing: "0.5em" },
            React.createElement(Stack, { direction: "row", spacing: "0.5em", alignItems: "flex-start" },
                React.createElement(Typography, null, "App version:"),
                React.createElement(Typography, null, version),
                React.createElement(Chip, { size: "small", label: versionLabel, sx: { backgroundColor: '#6c3477' } })),
            Boolean(platformInfo.gitSHA) && (React.createElement(Stack, { direction: "row", spacing: "0.5em" },
                React.createElement(Typography, null, "Git commit:"),
                React.createElement(Chip, { size: "small", icon: renderIcon(Icon.GITHUB, { fontSize: 'small' }), label: platformInfo.gitSHA }))),
            Boolean(platformInfo.browserName) && Boolean(platformInfo.browserVersion) && (React.createElement(Stack, { direction: "row", spacing: "0.5em" },
                React.createElement(Typography, null, "Browser:"),
                React.createElement(Typography, null, platformInfo.browserName),
                React.createElement(Typography, null, platformInfo.browserVersion))),
            Boolean(platformInfo.electronVersion) && (React.createElement(Stack, { direction: "row", spacing: "0.5em" },
                React.createElement(Typography, null, "Electron Version:"),
                React.createElement(Typography, null, platformInfo.browserVersion))),
            Boolean(platformInfo.nodeVersion) && (React.createElement(Stack, { direction: "row", spacing: "0.5em" },
                React.createElement(Typography, null, "Node Version:"),
                React.createElement(Typography, null, platformInfo.nodeVersion))))));
};
export default AboutView;
//# sourceMappingURL=AboutView.js.map